import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { SelectSizeText } from '../utils';
import { AddToCartMaternity } from './styled';

export default function MaternityCardCTA(props) {
  const { product, showLoader } = props;
  const productId = product;
  return (
    <AddToCartMaternity verm={showLoader} data-productid={productId}>
      {showLoader ? <CssLoader /> : SelectSizeText()}
    </AddToCartMaternity>
  );
}
